/*$(document).ready(function () {
    (function ($) {
        $(document.querySelectorAll('[data-teaserpromoclick]')).click(function () {
            var value = $(this).data('teaserpromoclick');
            promoLayerPush(teaserJson, value);
        });

        $(document.querySelectorAll('[data-segmentypromoclick]')).click(function () {
            var value = $(this).data('segmentypromoclick');
            promoLayerPush(segmentyJson, value);
        });

        $(document.querySelectorAll('[data-topnabidkapromoclick]')).click(function () {
            var value = $(this).data('topnabidkapromoclick');
            promoLayerPush(topKapacityJson, value);
        });

        $(document.querySelectorAll('[data-doporucujemepromoclick]')).click(function () {
            var value = $(this).data('doporucujemepromoclick');
            promoLayerPush(doporucujemeJson, value);
        });

        $(document.querySelectorAll('[data-fmpromoclick]')).click(function () {
            var value = $(this).data('fmpromoclick');
            promoLayerPush(fmJson, value);
        });

    })(jQuery);
});

function promoLayerPush(p, val) {
    var layer = "";

    for (i in p) {

        if (p[i].ecommerce.promoClick.promotions.id == val) {
            layer = p[i];
            var dataLayer = window.dataLayer = window.dataLayer || [];
            dataLayer.push(layer);
            break;
        }
    }
};

$(document).ready(function () {
    (function ($) {
        //po stisku tlačítka se zájezdy udělám push dataLayeru
        $('[data-productclick]').click(function () {
            var dataLayer = window.dataLayer = window.dataLayer || [];
            dataLayer.push(oblibeneZajezdyStrediskaJson);
        });
    })(jQuery);

    //když bych se nacházel již na stránce s oblíbenými zájezdy (např. při obnovení stránky), tak dle URL adresy udělám push dataLayeru
    if (window.location.href.indexOf("list") > -1) {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push(oblibeneZajezdyStrediskaJson);
    }
});

$(document).ready(function () {
    (function ($) {
        //po stisku tlačítka se zájezdy udělám push dataLayeru
        $('[data-productclick]').click(function () {
            var dataLayer = window.dataLayer = window.dataLayer || [];
            dataLayer.push(oblibeneZajezdyOblastiJson);
        });
    })(jQuery);

    //když bych se nacházel již na stránce s oblíbenými zájezdy (např. při obnovení stránky), tak dle URL adresy udělám push dataLayeru
    if (window.location.href.indexOf("accommodation") > -1) {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push(oblibeneZajezdyOblastiJson);
    }
});

$(document).ready(function () {
    (function ($) {
        //po stisku tlačítka se zájezdy udělám push dataLayeru
        $('[data-productclick]').click(function () {
            var dataLayer = window.dataLayer = window.dataLayer || [];
            dataLayer.push(oblibeneZajezdyZemeJson);
        });

        //když bych se nacházel již na stránce s oblíbenými zájezdy (např. při obnovení stránky), tak dle URL adresy udělám push dataLayeru
        if (window.location.href.indexOf("accommodation") > -1) {
            var dataLayer = window.dataLayer = window.dataLayer || [];
            dataLayer.push(oblibeneZajezdyZemeJson);
        }
    })(jQuery);
});*/



/*var selectCenaOd = document.getElementById('cenaOdSelect');
var selectCenaDo = document.getElementById('cenaDoSelect');
document.getElementById("sliderMaxValue").value = selectCenaDo.options[selectCenaDo.selectedIndex].value;
document.getElementById("sliderMinValue").value = selectCenaOd.options[selectCenaOd.selectedIndex].value;

$(".js-slider").on("sliderSet", function (e, min, max) {
    var maxVal = document.getElementById("sliderMaxValue").value;
    var minVal = document.getElementById("sliderMinValue").value;
    if (min != minVal) {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'trackClickEvent',
            eventCategory: 'Click',
            eventAction: 'setSearchFilterCenaZajezdu',
            eventLabel: min,
            eventValue: '0'
        });
        document.getElementById("sliderMinValue").value = min;
    }
    else if (max != maxVal) {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'trackClickEvent',
            eventCategory: 'Click',
            eventAction: 'setSearchFilterCenaZajezdu',
            eventLabel: max,
            eventValue: '0'
        });
        document.getElementById("sliderMaxValue").value = max;
    }
});*/


function pushDataLayer(object) {
    dataLayer.push();
}


$(document).ready(function (e) {

    $("body").on("click", ".persoo-ac-search-bar__submit", function (e) {

        var valueToSearch = $(this).parent().find("input").val();
        var pageType = $("body").attr("data-page-type");

        var objectToPush = {
            'event': 'trackFulltext',
            'eventCategory': 'FulltextSent',
            'eventAction': valueToSearch,
            'eventValue': 1,
            'eventLabel': pageType
        };

        dataLayer.push(
            objectToPush
        );

    });

    $("body").on("click" , ".persoo-autocompleteDataset__items__item", function (e) {
        eventLabel = $("body").attr("data-page-type");
        eventAction = $(this).text().replace(/  /g,'').replace(/\n/g,'').replace(/Detail hotelu/g,'');
        // console.log($(this).parent().parent().find('.persoo-autocompleteDataset__header').text()); // category

        var dataLayerObject = {
            'event': 'trackClickEvent',
            'eventCategory': 'FulltextSentNaseptavac',
            'eventAction': eventAction,
            'eventValue': 1,
            'eventLabel': eventLabel
        };

        dataLayer.push(
            dataLayerObject
        );
    });


    $(".js-staticGtmPush").each(function (index) {
        var eventLabel = $(this).attr("data-event-label") || false;
        var eventAction = $(this).attr("data-event-action") || false;
        var eventCategory = $(this).attr("data-event-category") || false;
        var event = $(this).attr("data-event") || false;

        dataLayer.push({
            'eventLabel': eventLabel,
            'eventAction': eventAction,
            'eventCategory': eventCategory,
            'event': event
        });

    });

    $("body").on("click" , ".js-dataLayer--click", function (e) {

        var eventLabel = $(this).attr("data-event-label") || false;

        if(eventLabel == "inherit"){
            eventLabel = $("body").attr("data-page-type");
        }

        var eventAction = $(this).attr("data-event-action") || false;
        var eventCategory = $(this).attr("data-event-category") || false;
        var event = $(this).attr("data-event") || false;
        var eventValue = $(this).attr("data-event-value") || false;

        var dataLayerObject = {
            'event': event,
            'eventCategory': eventCategory,
            'eventAction': eventAction,
            'eventValue': eventValue,
            'eventLabel': eventLabel
        };

        dataLayer.push(dataLayerObject);

    });


});



